import React, { useEffect, useState } from "react"
import cx from "classnames"
import { Link } from "gatsby"
import VizSensor from "react-visibility-sensor"

import * as s from "./ProductCardV2.module.scss"

import { getVariant } from "./util.ts"
import { stringToColor } from "@components/main/product-option-selector/util.ts"

import ArrowRight from "@assets/svg/arrowRight.inline.svg"
import pricePercent from "@utils/pricePercent"

export const ProductCardV2 = ({
  product,
  className,
  shopifyApi,
  onItemClick,
  idx,
}) => {
  const [selectedVaraint, setSelectedVaraint] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  useEffect(() => {
    setSelectedVaraint(getVariant(product))
  }, [product])

  const onChangeVisibility = isActive => {
    if (isActive) {
      setIsVisible(true)
    }
  }

  return (
    <div
      key={idx && idx}
      className={`${s.ProductCard} ${className && className} ${
        isVisible && s.ProductCard___visible
      }`}
    >
      {selectedVaraint && (
        <VizSensor partialVisibility onChange={e => onChangeVisibility(e)}>
          <>
            <div className={s.ProductCarousel}>
              <Link
                to={`/shop/${product.handle}`}
                onClick={onItemClick && onItemClick}
              >
                {product.variants.map((variant, i) => {
                  if (variant.image) {
                    return (
                      <div
                        className={cx(s.ProductCarousel__varaint, {
                          [s.ProductCarousel__varaint___active]:
                            selectedVaraint === variant,
                        })}
                        key={i}
                        style={{
                          backgroundImage: `url(${variant.image.originalSrc})`,
                        }}
                      />
                    )
                  }
                  return null
                })}

                {product.media &&
                  product.media.map(({ image }, i) => {
                    if (image && i === 0) {
                      return (
                        <div
                          className={`${s.ProductCarousel__varaint} ${s.ProductCarousel__varaint___active}`}
                          key={i}
                          style={{
                            backgroundImage: `url(${image.originalSrc})`,
                          }}
                        />
                      )
                    }
                    return null
                  })}
              </Link>

              {product.options &&
                product.options.length > 1 &&
                selectedVaraint.selectedOptions && (
                  <ProductOptionSelector
                    options={product.options.filter(o => {
                      return o.name === "Colour"
                    })}
                    selected={selectedVaraint.selectedOptions.filter(o => {
                      return o.name === "Colour"
                    })}
                    onClick={option => {
                      setSelectedVaraint(getVariant(product, option))
                    }}
                  />
                )}
            </div>

            <Link to={`/shop/${product.handle}`}>
              <span className={s.ProductCard__title}>
                <h3>{product.title}</h3>
                <ArrowRight />
              </span>

              <h4 className={s.ProductCard__price}>
                {selectedVaraint.compareAtPrice ? (
                  <>
                    <span className={s.ProductCard__pricePercent}>
                      {`${pricePercent(selectedVaraint)} % off`}
                    </span>
                    <span className={s.ProductCard__priceCurrent}>
                      Now{" "}
                      {shopifyApi ? (
                        <>
                          {product.variants.length > 1 && "From "}£
                          {selectedVaraint.price.toString().includes(".")
                            ? selectedVaraint.price
                            : (selectedVaraint.price / 100).toFixed(2)}
                        </>
                      ) : (
                        <>
                          {product.variants.length > 1 && "From "}£
                          {selectedVaraint.price}
                        </>
                      )}
                    </span>
                    <span className={s.ProductCard__pricePrevious}>
                      Was £{selectedVaraint.compareAtPrice}
                    </span>
                  </>
                ) : (
                  <>
                    {shopifyApi ? (
                      <>
                        {product.variants.length > 1 && "From "}£
                        {selectedVaraint.price.toString().includes(".")
                          ? selectedVaraint.price
                          : (selectedVaraint.price / 100).toFixed(2)}
                      </>
                    ) : (
                      <>
                        {product.variants.length > 1 && "From "}£
                        {selectedVaraint.price}
                      </>
                    )}
                  </>
                )}
              </h4>
            </Link>
          </>
        </VizSensor>
      )}
    </div>
  )
}

const ProductOptionSelector = ({ options, onClick, selected }) => {
  if (options.length < 1) return <></>
  return (
    <div className={s.ProductOptionSelector}>
      {options[0].values.map((value, idx) => {
        return (
          <div
            key={idx}
            className={cx(s.ProductOptionSelector__variant, {
              [s.ProductOptionSelector__variant___active]:
                selected[0] && selected[0].value === value,
            })}
            onClick={() =>
              onClick({
                name: options[0].name,
                value,
              })
            }
            role="button"
            tabIndex="0"
            aria-label={`Select ${value}`}
          >
            <div style={{ backgroundColor: stringToColor(value) }} />
          </div>
        )
      })}
    </div>
  )
}
